import { Box, Stack, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";

// Title row at the top of every page, with the page's main actions on the right
export default function PageHeader({ title, subtitle, actions }) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      gap={2}
      sx={{ mb: 3 }}
    >
      <Helmet>
        <title>{title} | Risk Manager</title>
      </Helmet>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h5" component="h1">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack direction="row" gap={1} flexWrap="wrap" alignItems="center">
          {actions}
        </Stack>
      )}
    </Stack>
  );
}
